module.exports = __webpack_public_path__ + "static/media/s9.8e09db03.jpg";